import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import TeamBadge from '@/components/base/TeamBadge';
import { useSEO } from '@/hooks/useSEO';
import { allPlayers, getTeam } from '@/utils/data';

export default function PlayersPage() {
  useSEO({
    title: '球员数据分析 - 篮球比分',
    description: '汇总国内外联赛主要球员的个人资料、本赛季场均数据与近期表现趋势，帮助球迷快速了解球员状态。',
    keywords: '篮球球员,球员数据,球员资料,NBA球员,CBA球员',
  });

  return (
    <div className="px-4 md:px-6 py-6 animate-fade-up">
      <Breadcrumb items={[{ label: '首页', to: '/' }, { label: '球员' }]} />
      <header className="mt-4 mb-6">
        <h1 className="font-heading font-extrabold text-2xl md:text-3xl text-foreground-950">球员数据</h1>
        <p className="mt-2 text-sm md:text-[15px] text-foreground-600 max-w-3xl">
          查看各联赛主要球员的赛季数据与表现趋势，点击球员卡片可查看详细资料。
        </p>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {allPlayers.map((p) => {
          const team = getTeam(p.teamId);
          return (
            <Link
              key={p.id}
              to={`/player/${p.id}`}
              className="group rounded-lg bg-background-50 border border-background-200/80 hover:border-primary-300 overflow-hidden transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-4 p-4">
                <span
                  className="w-14 h-14 rounded-lg flex items-center justify-center shrink-0"
                  style={{ backgroundColor: team?.color }}
                >
                  <span className="font-heading font-extrabold text-xl text-white">{p.number}</span>
                </span>
                <div className="min-w-0 flex-1">
                  <p className="text-base font-semibold text-foreground-950 truncate group-hover:text-primary-600 transition-colors">{p.name}</p>
                  <p className="text-xs text-foreground-500 truncate">{p.position} · {p.country}</p>
                  <div className="mt-1.5 flex items-center gap-1.5">
                    <TeamBadge team={team} size="sm" />
                    <span className="text-xs text-foreground-600 truncate">{team?.name}</span>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-3 border-t border-background-200/70 divide-x divide-background-200/70">
                <div className="px-2 py-2.5 text-center">
                  <span className="block font-heading font-bold text-foreground-950">{p.ppg}</span>
                  <span className="block text-[10px] text-foreground-500">得分</span>
                </div>
                <div className="px-2 py-2.5 text-center">
                  <span className="block font-heading font-bold text-foreground-950">{p.rpg}</span>
                  <span className="block text-[10px] text-foreground-500">篮板</span>
                </div>
                <div className="px-2 py-2.5 text-center">
                  <span className="block font-heading font-bold text-foreground-950">{p.apg}</span>
                  <span className="block text-[10px] text-foreground-500">助攻</span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}